import { type AbstractImage, NativeImage } from '@mntn-dev/ui-utilities'
import type { Person } from '../../../../types/person.ts'
import { Avatar, type AvatarProps } from '../../../avatar/avatar.tsx'
import type { AvatarEntity } from '../../../avatar/types.ts'
import { useCardContext } from '../../use-card.ts'

export type CardDetailsAvatarProps = AvatarProps & {
  entity?: AvatarEntity
  image?: AbstractImage
  person?: Person
}

export const CardDetailsAvatar = ({
  entity,
  image = NativeImage,
  size = 'med',
  ...avatarProps
}: CardDetailsAvatarProps) => {
  const { scale } = useCardContext()

  return scale === 'sm' ? null : (
    <div className="self-center">
      <Avatar size={size ?? (scale === 'lg' ? 'med' : 'sm')} {...avatarProps}>
        {entity && <Avatar.Entity entity={entity} image={image} />}
      </Avatar>
    </div>
  )
}
